import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { FooterComponent } from './components/footer/footer.component';
import { PageLayoutComponent } from './components/page-layout/page-layout.component';
import { PageLayoutContentDirective } from './components/page-layout/page-layout-content.directive';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { LAYOUT } from './layout.constants';
import { LayoutService } from './services/layout.service';

@Component({
  selector: 'rms-layout',
  templateUrl: './layout.component.html',
  imports: [
    BaseLayoutComponent,
    SidenavComponent,
    ToolbarComponent,
    FooterComponent,
    ProgressBarComponent,
    PageLayoutComponent,
    PageLayoutContentDirective,
    MatSidenavModule,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class LayoutComponent {
  public readonly footerVisible = LAYOUT.footerVisible;

  public readonly sidenavCollapsed$: Observable<boolean>;
  public readonly sidenavOpen$: Observable<boolean>;
  public readonly sidenavDisableClose$: Observable<boolean>;
  public readonly sidenavFixedInViewport$: Observable<boolean>;
  public readonly sidenavMode$: Observable<MatDrawerMode>;

  private readonly layoutService = inject(LayoutService);

  constructor() {
    this.sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
    this.sidenavOpen$ = this.layoutService.sidenavOpen$;
    this.sidenavDisableClose$ = this.layoutService.isDesktop$;
    this.sidenavFixedInViewport$ = this.layoutService.isDesktop$.pipe(map((isDesktop) => !isDesktop));
    this.sidenavMode$ = this.layoutService.isDesktop$.pipe(map((isDesktop) => (isDesktop ? 'side' : 'over')));
  }

  public onSidenavClosed(): void {
    this.layoutService.closeSidenav();
  }
}
